module.exports = __webpack_public_path__ + "img/art-58.fce7a2c6.png";